import React, { useState } from 'react';
import { auth, googleProvider } from './firebaseConfig';
import { signInWithPopup } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';

function Login() {
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleGoogleLogin = async () => {
    setLoading(true);
    setError('');
    try {
      await signInWithPopup(auth, googleProvider);
    } catch (err) {
      setError('Sign in failed. Please make sure you are opening this app directly in Safari or Chrome — not from a text message or Instagram link.');
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#000',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#fff',
      textAlign: 'center',
      padding: '40px 20px',
    }}>
      <h1 style={{
        fontFamily: 'Bangers, sans-serif',
        fontSize: 'clamp(2rem, 6vw, 3.5rem)',
        letterSpacing: '2px',
        marginBottom: '6px',
      }}>
        🤼 Wrestling Journey 365
      </h1>
      <p style={{
        fontSize: '1rem',
        marginBottom: '40px',
        color: '#FFD700',
        fontFamily: 'Bangers, sans-serif',
        letterSpacing: '1px',
      }}>
        Stay on the GRIND
      </p>

      {/* Fargo Campaign Button */}
      <button
        onClick={() => navigate('/fargo')}
        style={{
          width: '100%',
          maxWidth: '340px',
          backgroundColor: '#FFD700',
          color: '#000',
          border: 'none',
          borderRadius: '10px',
          padding: '18px 24px',
          fontSize: '1.1rem',
          fontFamily: 'Bangers, sans-serif',
          letterSpacing: '2px',
          cursor: 'pointer',
          marginBottom: '8px',
          fontWeight: 'bold',
        }}
      >
        🤼 Help Send Ben to Fargo!
      </button>
      <p style={{ color: '#888', fontSize: '0.85rem', marginBottom: '40px' }}>
        Support Benjamin's journey to the national championship
      </p>

      {/* Divider */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        width: '100%',
        maxWidth: '340px',
        marginBottom: '40px',
      }}>
        <div style={{ flex: 1, height: '1px', backgroundColor: '#333' }} />
        <span style={{ color: '#555', fontSize: '12px', letterSpacing: '2px', textTransform: 'uppercase' }}>or</span>
        <div style={{ flex: 1, height: '1px', backgroundColor: '#333' }} />
      </div>

      {/* App Login */}
      <p style={{
        fontSize: '0.95rem',
        marginBottom: '16px',
        color: '#aaa',
        maxWidth: '300px',
        lineHeight: '1.6',
      }}>
        Sign in to track your workouts, set GRIND Goals, and access exclusive content
      </p>

      <div style={{
        backgroundColor: '#1a1a1a',
        borderRadius: '8px',
        padding: '10px 16px',
        marginBottom: '20px',
        maxWidth: '340px',
        width: '100%',
      }}>
        <p style={{ color: '#FFD700', fontSize: '0.8rem', margin: 0 }}>
          📱 <strong>iPhone users:</strong> Open directly in Safari — not from a text or Instagram link
        </p>
      </div>

      <button
        onClick={handleGoogleLogin}
        disabled={loading}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          backgroundColor: '#fff',
          color: '#000',
          border: 'none',
          borderRadius: '8px',
          padding: '14px 28px',
          fontSize: '1rem',
          fontWeight: 'bold',
          cursor: loading ? 'not-allowed' : 'pointer',
          opacity: loading ? 0.7 : 1,
          marginBottom: '16px',
        }}
      >
        <img
          src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg"
          alt="Google"
          style={{ width: '22px', height: '22px' }}
        />
        {loading ? 'Signing in...' : 'Sign in with Google'}
      </button>

      {error && (
        <div style={{
          backgroundColor: '#1a1a1a',
          borderRadius: '8px',
          padding: '14px',
          maxWidth: '340px',
          marginTop: '8px',
        }}>
          <p style={{ color: '#ff4444', fontSize: '0.85rem', margin: 0 }}>
            {error}
          </p>
        </div>
      )}

      <p style={{ marginTop: '30px', color: '#444', fontSize: '0.8rem' }}>
        @BenjaminKinney365
      </p>
    </div>
  );
}

export default Login;